import Vue from "vue";
import { customers } from "@/customers";
import * as swal from 'sweetalert2';
import { localizationService, webRestService } from "@/main";
import { getLogosHTML, handleBackground, handleCustomerLogo, handleFavicon } from "@/utils/util";
export default Vue.extend({
    computed: {
        customer() {
            return customers[this.$route.params.customerCode];
        },
        customerCode() {
            return this.$route.params.customerCode;
        },
        otpCode() {
            return this.$route.query.code || undefined;
        },
        locale() {
            return this.$route.query.locale || undefined;
        }
    },
    data() {
        return {
            status: 0,
            formCode: "",
            customerLogo: "",
            formTitle: "",
            localizationService,
            errorMessage: "",
            htmlToInject: "",
            showLogos: false
        };
    },
    mounted() {
        let favicon = require("@/assets/favicons/smartform.ico");
        if (this.locale) {
            this.$i18n.locale = this.locale;
        }
        webRestService
            .getCustomerConfig(this.customerCode, this.otpCode, true)
            .then((response) => {
            if (response) {
                this.htmlToInject = getLogosHTML(response);
                this.showLogos = !!this.htmlToInject;
                this.formCode = response.form_code;
                this.formTitle = response.form_title;
                sessionStorage.setItem('tokenExpiration', response.token_expiration.toString());
                favicon = handleFavicon(response);
                this.customerLogo = handleCustomerLogo(response);
                handleBackground(response);
                webRestService.confirmFormData(JSON.stringify({ otp_code: this.$route.query.code }), this.customerCode)
                    .then((response) => {
                    swal.fire({
                        title: this.localizationService.FormLoc('richiesta_elaborata'),
                        text: this.localizationService.FormLoc('richiesta_processata'),
                        icon: "success",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                    });
                    this.status = 1;
                })
                    .catch(() => {
                    this.status = -1;
                });
            }
            else {
                this.$router.push(this.customerCode + '/login');
            }
        })
            .finally(() => {
            document.querySelectorAll('[rel="icon"]')[0].href = favicon ? favicon : "";
            document.body.style.backgroundAttachment = "fixed";
            document.body.style.backgroundRepeat = "no-repeat";
            document.body.style.backgroundSize = "cover";
        });
    },
    methods: {}
});
